module.exports = __webpack_public_path__ + "static/media/mastercard-logo.01b84d88.png";